module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('ul', {
    staticClass: "header-links"
  }, [_c('li', {
    staticClass: "header-spacer"
  }, [_c('router-link', {
    staticClass: "header-link",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Johann")])], 1), _c('li', {
    staticClass: "header-spacer"
  }, [_c('router-link', {
    staticClass: "header-link",
    attrs: {
      "to": "/code",
      "exact": ""
    }
  }, [_vm._v("Code")])], 1), _c('li', {
    staticClass: "header-spacer"
  }, [_c('router-link', {
    staticClass: "header-link",
    attrs: {
      "to": "/music",
      "exact": ""
    }
  }, [_vm._v("Music")])], 1), _c('li', {
    staticClass: "header-spacer"
  }, [_c('router-link', {
    staticClass: "header-link",
    attrs: {
      "to": "/stuff",
      "exact": ""
    }
  }, [_vm._v("Stuff")])], 1)]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "main-content"
  }, [_c('transition', {
    attrs: {
      "name": _vm.slideDirection
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c096018"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 32
// module chunks = 0